<main class="container">
  @if (!isLoading) {
    <!-- product details data -->
    <section class="products-details">
      <!-- product bread crumbs section -->
      <div class="products-details__options">
        <!-- bread crumbs section -->
        <pwj-breadcrumbs [breadcrumbsData]="breadcrumbsData"></pwj-breadcrumbs>
        <!-- options menu -->
        <pwj-options-menu
          [menuOptions]="menuOptions"
          [isRowMode]="true"></pwj-options-menu>
      </div>
      <!-- product preview section-->
      <div class="products-details__surface">
        <pwj-product-preview
          [previewData]="productPreviewData"></pwj-product-preview>
      </div>
      <!-- product tags section -->
      @if (productTags && productTags.length > 0) {
        <div class="products-details__surface products-details__surface--compact">
          <pwj-product-tags [tagsData]="productTags"></pwj-product-tags>
        </div>
      }
      <!-- product navigation tabs section -->
      @if (hasVisibleNavigationTabs) {
        <div class="products-details__sticky-nav">
          <pwj-product-navigation-tabs
            [tabsData]="navigationTabsData"
            (activeSectionChange)="
              onActiveSectionChange($event)
            "></pwj-product-navigation-tabs>
        </div>
      }

      @if (
        isSectionVisible('description') &&
        (hasLongProductDescription ||
          hasClimaticData ||
          (usageData && usageData.length > 0) ||
          expertOpinionsData?.specialist_note ||
          (expertOpinionsData?.specialist_photos?.length || 0) > 0 ||
          (expertOpinionsData?.specialist_video?.length || 0) > 0 ||
          (faqData && faqData.length > 0))
      ) {
        <div class="products-details__anchor-section">
          @if (hasLongProductDescription) {
            <div class="products-details__surface">
              <pwj-product-description
                [productDescription]="productDescription"></pwj-product-description>
            </div>
          }
          @if (hasClimaticData) {
            <div class="products-details__surface">
              <pwj-product-climatic-properties
                [climaticData]="climaticData"></pwj-product-climatic-properties>
            </div>
          }
          @if (usageData && usageData.length > 0) {
            <div class="products-details__surface">
              <pwj-product-usage [usageData]="usageData"></pwj-product-usage>
            </div>
          }
          @if (
            expertOpinionsData?.specialist_note ||
            (expertOpinionsData?.specialist_photos?.length || 0) > 0 ||
            (expertOpinionsData?.specialist_video?.length || 0) > 0
          ) {
            <div class="products-details__surface">
              <pwj-product-expert-opinions
                [expertOpinionsData]="
                  expertOpinionsData
                "></pwj-product-expert-opinions>
            </div>
          }
          @if (faqData && faqData.length > 0) {
            <div class="products-details__surface">
              <pwj-faq-section
                [verticalMargin]="false"
                [faqData]="faqData"></pwj-faq-section>
            </div>
          }
        </div>
      }

      @if (
        hasCatalogsAndDocsSection &&
        (isSectionVisible('specifications') || isSectionVisible('catalogsAndDocs'))
      ) {
        <div class="products-details__anchor-section">
          @if (
            (isSectionVisible('specifications') && hasAdditionalSpecifications) ||
            (isSectionVisible('catalogsAndDocs') && productCatalogs?.length)
          ) {
            <div class="products-details__surface">
              @if (isSectionVisible('specifications') && hasAdditionalSpecifications) {
                <pwj-product-additional-properties
                  [additionalProperties]="
                    additionalSpecificationData
                  "></pwj-product-additional-properties>
              }
              @if (isSectionVisible('catalogsAndDocs') && productCatalogs?.length) {
                <pwj-product-catalogs
                  [catalogs]="productCatalogs"
                  [stackedBelowSpecs]="
                    isSectionVisible('specifications') && hasAdditionalSpecifications
                  " />
              }
            </div>
          }
          @if (
            isSectionVisible('catalogsAndDocs') &&
            productDocuments?.length &&
            !productCatalogs?.length
          ) {
            <div class="products-details__surface products-details__documents">
              <h3 class="products-details__documents-title">
                {{ 'products.documents' | translate }}
              </h3>
              <div class="products-details__documents-files">
                @for (doc of productDocuments; track doc._id) {
                  <a
                    class="products-details__file-card"
                    [href]="productDocumentHref(doc)"
                    target="_blank"
                    rel="noopener noreferrer">
                    <span
                      class="products-details__file-card-icon"
                      aria-hidden="true">
                      <i class="iconsax" icon-name="document-text-1"></i>
                    </span>
                    <span class="products-details__file-card-name">{{
                      productDocumentDisplayName(doc) ||
                        ('products.document' | translate)
                    }}</span>
                  </a>
                }
              </div>
            </div>
          }
        </div>
      }

      @if (isSectionVisible('videos') && productVideoItems?.length) {
        <div class="products-details__anchor-section">
          <div class="products-details__surface">
            <pwj-product-videos-section
              [videos]="productVideoItems"></pwj-product-videos-section>
          </div>
        </div>
      }

      @if (isSectionVisible('comments')) {
        <div class="products-details__anchor-section">
          <pwj-comment-form-box
            [pageId]="productId"
            pageName="product_id"></pwj-comment-form-box>
          @if ((commentsService.commentsData()?.length || 0) > 0) {
            <div class="products-details__surface">
              <pwj-product-comments></pwj-product-comments>
            </div>
          }
        </div>
      }    </section>
  } @else {
    <!-- skeleton loading -->
    <div>
      <pwj-product-details-skeleton></pwj-product-details-skeleton>
    </div>
  }
</main>
